/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR`)
};

const es_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR`)
};

const de_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR`)
};

const nl_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR`)
};

const fr_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR`)
};

const it_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR`)
};

const pt_br2_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR`)
};

const pt_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TMB`)
};

const ja_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR`)
};

const zh_bmr_result_bmr = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_result_bmr = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_result_bmr(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_result_bmr", locale)
	if (locale === "en") return en_bmr_result_bmr(inputs)
	if (locale === "es") return es_bmr_result_bmr(inputs)
	if (locale === "de") return de_bmr_result_bmr(inputs)
	if (locale === "nl") return nl_bmr_result_bmr(inputs)
	if (locale === "fr") return fr_bmr_result_bmr(inputs)
	if (locale === "it") return it_bmr_result_bmr(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_result_bmr(inputs)
	if (locale === "pt") return pt_bmr_result_bmr(inputs)
	if (locale === "ja") return ja_bmr_result_bmr(inputs)
	return zh_bmr_result_bmr(inputs)
};